/** Non-personal launch codes only. Never forward arbitrary UTM values to billing. */
import { isAnalyticsEnabled } from './analytics';

export const ACQUISITION_CAMPAIGNS = [
  'pro_demo_20260908_youtube_pitch',
  'pro_demo_20260908_youtube_harmony',
  'pro_demo_20260908_alternativeto_listing',
  'pro_demo_20260908_x_harmony',
  'pro_demo_20260908_reddit_harmony',
  'pro_demo_20260908_producthunt_launch',
] as const;

export function sanitizeAcquisitionCampaign(value: unknown): string | undefined {
  return typeof value === 'string' && (ACQUISITION_CAMPAIGNS as readonly string[]).includes(value)
    ? value : undefined;
}

export function getAnalyticsAcquisitionCampaign(): string | undefined {
  // AnalyticsConsent resolves region, saved refusal and GPC into the same
  // flag used by GA. An absent saved choice is not a refusal outside consent
  // regions. Pending/failed resolution stays disabled; no choice is invented.
  if (!isAnalyticsEnabled()) return undefined;
  try {
    const query = new URLSearchParams(window.location.search);
    // A new campaign overrides a previous one even if the new value is unknown.
    const attribution = ['utm_source', 'utm_campaign', 'utm_content'].some((key) => query.has(key)) ? {
      campaign_source: query.get('utm_source'),
      campaign_name: query.get('utm_campaign'),
      campaign_content: query.get('utm_content'),
    } : JSON.parse(window.sessionStorage.getItem('la_ga_attribution') || 'null');
    if (attribution?.campaign_name !== 'pro_demo_20260908') return undefined;
    return sanitizeAcquisitionCampaign(`pro_demo_20260908_${attribution.campaign_source}_${attribution.campaign_content}`);
  } catch {
    return undefined;
  }
}
